import { useMemo } from 'react';
import { ResourceAvatar } from '@ui';
import { HubRouteLocation, RouteLocationType, SegmentTypeEnum } from '@/api/apis/route';
import { OrganType } from '@/api/apis/case';
import { RouteSegmentType } from '@/types/route';
import { ResourceCard } from './ResourceCard';

const FALLBACK_HUB_LABEL = 'HUB';

type BenchmarkResourceType = 'device' | 'clinical-specialist' | 'retrieval-surgeon';

const BENCHMARK_RESOURCES: { title: string; type: BenchmarkResourceType }[] = [
  { title: 'Clinical Specialist', type: 'clinical-specialist' },
  { title: 'OCS Device', type: 'device' },
  { title: 'Surgeon', type: 'retrieval-surgeon' },
];

type BenchmarkResourcesListProps = {
  routePlanSegments: RouteSegmentType[];
  organType: OrganType;
  locations: RouteLocationType[];
};

type BenchmarkResourceItemProps = {
  title: string;
  subTitle: string;
  type: BenchmarkResourceType;
  organType: OrganType;
};

const BenchmarkResourceItem = ({ type, organType, title, subTitle }: BenchmarkResourceItemProps) => (
  <ResourceCard className="gap-2">
    <ResourceAvatar type={type} size="md" radius="md" organ={organType} />
    <span className="text-s-r text-base-10">{`${title}, ${subTitle}`}</span>
  </ResourceCard>
);

export const BenchmarkResourcesList = ({ locations, routePlanSegments, organType }: BenchmarkResourcesListProps) => {
  const currentHubCode = useMemo(() => {
    const hubSegment = routePlanSegments.find((s) => s.type === SegmentTypeEnum.hospital);
    const hubLocation = locations.find((s) => s.id === hubSegment?.startLocation.locationId);

    return (hubLocation as HubRouteLocation | undefined)?.code || FALLBACK_HUB_LABEL;
  }, [routePlanSegments, locations]);

  return (
    <div className="flex gap-2 justify-end grow">
      {BENCHMARK_RESOURCES.map(({ title, type }) => (
        <BenchmarkResourceItem key={type} title={title} subTitle={currentHubCode} type={type} organType={organType} />
      ))}
    </div>
  );
};
